// app.module.ts
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { LoadingComponent } from './components/core/loading/loading.component';
import { GameComponent } from './components/core/game/game.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared.module';
import { OnboardingComponent } from './components/ui/overlays/onboarding/onboarding.component';
import { GenderSelectComponent } from './components/ui/overlays/gender-select/gender-select.component';
import { ResumeComponent } from './components/ui/modals/resume/resume.component';
import { QuestionComponent } from './components/ui/modals/question/question.component';
import { FreidComponent } from './components/nps/nps-games/freid/freid.component';
import { MatchThreeComponent } from './components/nps/nps-games/freid/match-three/match-three.component';
import { SurveyComponent } from './components/nps/nps-games/freid/survey/survey.component';
import { WitchComponent } from './components/nps/nps-games/witch/witch.component';
import { FindAPairComponent } from './components/nps/nps-games/witch/find-a-pair/find-a-pair.component';
import { NpsDetailComponent } from './components/core/nps-detail/nps-detail.component';
import { NpsDialogComponent } from './components/nps/nps-dialog/nps-dialog.component';
import { PaymentComponent } from './components/ui/modals/payment/payment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PuzzleComponent } from './components/nps/nps-games/puzzle/puzzle.component';
import { HowToPlayComponent } from './components/ui/overlays/how-to-play/how-to-play.component';
import { DelayedClassDirective } from './directives/delayed-class.directive';
import { MetrikaService } from './services/metrika.service';
import { SubsModalComponent } from './components/ui/modals/subs-modal/subs-modal.component';

@NgModule({
  declarations: [
    NpsDetailComponent,
    NpsDialogComponent,
    AppComponent,
    LoadingComponent,
    GameComponent,
    OnboardingComponent,
    HowToPlayComponent,
    GenderSelectComponent,
    ResumeComponent,
    QuestionComponent,
    FreidComponent,
    MatchThreeComponent,
    SurveyComponent,
    WitchComponent,
		FindAPairComponent,
    PaymentComponent,
    PuzzleComponent,
    DelayedClassDirective,
    SubsModalComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  bootstrap: [AppComponent],
  providers: [MetrikaService],
  schemas: []
})
export class AppModule { }